<template>
  <div class="flex flex-col h-full w-full text-red-500 bg-yellow-500">
    <div class="m-auto text-center">
      <div class="splash-title-and-image">
        <img alt="blissing logo text" class="animate fade-in blissing-logo-text ml-4 w-32" src="https://blissing.s3-us-west-1.amazonaws.com/img/BLISSING-RED-TEXT.png" />
        <p class="animate fade-in animate__delay-2s text-2xl font-bold mb-8">THE WAY TO THE BETTER</p>
        <img alt="blissing logo" class="animate animate__delay-4s slide-in-bottom mx-auto w-32" src="https://blissing.s3-us-west-1.amazonaws.com/img/BLISSING-Logo.png" />
      </div>
    </div>

    <div class="skip-width flex w-full h-20 mx-auto">
      <div class="mx-auto">
        <span @click="progressForward()" class="text-3xl text-red-500 font-bold cursor-pointer">Click to Start</span>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "IntroFirstPage",
  methods:{
    progressForward(){
      Event.$emit('skipIntroForward');
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .blissing-logo-text{
    width: 26rem;
  }
</style>
